import { InjectionToken } from '@angular/core';
import { ActionReducer } from '@ngrx/store';

// This will be the root of all modules.
export const REACTIVE_STATE_ROOT = 'root';

export const WLM_GLOBAL_REDUCER_TOKEN = new InjectionToken<ActionReducer<any>>('Global State');
